// Configurazione API per il backend Laravel

export const API_CONFIG = {
    // URL base del backend Laravel
    // In development: '' (usa proxy Vite)
    // In production: '/backend' (Laravel è nella cartella backend)
    BASE_URL: import.meta.env.VITE_API_BASE_URL === '' || import.meta.env.VITE_API_BASE_URL === undefined
      ? (import.meta.env.DEV ? '' : '/backend')
      : import.meta.env.VITE_API_BASE_URL,
    
    // Endpoints
    ENDPOINTS: {
        CANDIDATURE: '/api/candidature',
        CANDIDATURE_BOZZA: '/api/candidature/bozza',
        CANDIDATURE_RECUPERA: '/api/candidature/recupera',
        RICHIESTE_CONTATTO: '/api/richieste-contatto',
        NEWSLETTER: '/api/newsletter',
        SEGNALAZIONI_PUBBLICHE: '/api/segnalazioni-pubbliche',
        SEGNALAZIONI_PUBBLICHE_CATEGORIE: '/api/segnalazioni-pubbliche/categorie',
        HEALTH: '/api/health',
    },
    
    // Headers di default
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
};

// Helper per costruire URL completo
export const buildApiUrl = (endpoint) => {
    return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper per richieste API (fetch-based, usato dal cliente)
export const apiRequest = async (endpoint, options = {}) => {
    const url = buildApiUrl(endpoint);
    
    const defaultOptions = {
        headers: {
            ...API_CONFIG.DEFAULT_HEADERS,
            ...options.headers
        }
    };
    
    const finalOptions = {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options.headers
        }
    };
    
    try {
        const response = await fetch(url, finalOptions);
        
        if (!response.ok) {
            let errorMessage = `Errore ${response.status}`;
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            } catch (e) {
                // Se non riesce a parsare JSON, usa messaggio di default
            }
            throw new Error(errorMessage);
        }
        
        return await response.json();
    } catch (error) {
        console.error(`API Error [${endpoint}]:`, error);
        throw error;
    }
};
